var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "referral-modal",
        width: "100%",
        adaptive: true,
        height: _vm.height,
        "max-width": 700,
        scrollable: true
      },
      on: { "before-close": _vm.beforeClose }
    },
    [
      _c("div", { staticClass: "container modal--container overflow-scroll" }, [
        _c(
          "div",
          {
            staticClass: "d-flex flex-wrap justify-content-end w-100 pt-3 px-2"
          },
          [
            _c(
              "button",
              {
                staticClass: "close",
                on: {
                  click: function($event) {
                    return _vm.$modal.hide("referral-modal")
                  }
                }
              },
              [
                _c(
                  "p",
                  {
                    staticClass: "close-text",
                    attrs: { "aria-hidden": "true" }
                  },
                  [_vm._v("×")]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c("div", { staticClass: "d-flex justify-content-center" }, [
            _c("img", {
              staticClass: "referral-icon",
              attrs: {
                src: require("../assets/img/referral-icon.png"),
                alt: "Referral Icon"
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "px-4" }, [
            _c("h1", [
              _vm._v(
                "\n          Earn a $100 gift card to your favourite hungerhub restaurant partner\n          when you refer a friend and their office signs up for hungerhub.\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "caption mt-3 mb-0" }, [
              _vm._v(
                "\n          Treat your friend to a free lunch too!\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "caption mt-2" }, [
              _vm._v(
                "\n          Qualified Referrals will receive a free lunch and you'll receive a\n          $100 gift card when their office signs up for Uncatering.\n        "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-row my-5 px-3" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.refLink,
                expression: "refLink"
              }
            ],
            ref: "refLink",
            staticClass: "form-control",
            attrs: { id: "refLink", type: "text", readonly: "" },
            domProps: { value: _vm.refLink },
            on: {
              focus: function($event) {
                return $event.target.select()
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.refLink = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "copy-btn hover-gray",
              attrs: { type: "button" },
              on: { click: _vm.copyLink }
            },
            [_vm._v("\n        Copy\n      ")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eb7175e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb7175e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReferralModal.vue
// module id = null
// module chunks = 